// Phase 7.1 — Mini list of tasks generated from a specific call.
// Rendered inside CallIntelligencePanel when a callId is present.
import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { tasksApi } from '../../api';
import {
  TASK_PRIORITY_COLORS,
  TASK_PRIORITY_LABELS,
  TASK_TYPE_LABELS,
} from '../Tasks/constants';

function formatDue(due) {
  if (!due) return null;
  const d = new Date(due);
  if (isNaN(d.getTime())) return due;
  return d.toLocaleString(undefined, {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

export default function TasksForCall({ callId }) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    if (!callId) return undefined;
    (async () => {
      setLoading(true);
      try {
        const res = await tasksApi.list({ call_id: callId, limit: 10 });
        if (!cancelled) setItems(res?.items || []);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [callId]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-xs text-muted-foreground py-2">
        <Loader2 className="w-3 h-3 animate-spin" /> Loading tasks…
      </div>
    );
  }
  if (!items.length) return null;

  return (
    <ul className="space-y-2" data-testid={`tasks-for-call-${callId}`}>
      {items.map((t) => {
        const due = formatDue(t.due_at);
        const pillCls = TASK_PRIORITY_COLORS[t.priority] || 'bg-gray-100 text-gray-700';
        return (
          <li key={t.id} className="flex items-start gap-2 text-sm">
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${pillCls}`}>
              {TASK_PRIORITY_LABELS[t.priority] || t.priority}
            </span>
            <span className="text-xs text-muted-foreground whitespace-nowrap">
              {TASK_TYPE_LABELS[t.task_type] || t.task_type}
            </span>
            <span className="flex-1 text-foreground">{t.title}</span>
            {due && <span className="text-xs text-muted-foreground whitespace-nowrap">{due}</span>}
          </li>
        );
      })}
    </ul>
  );
}
